/** Somente apresentação: conserva a referência original no e-mail e no banco. */
export function tituloEsim(texto: string): string {
  if (!/\[ESIM:[0-9a-f-]{36}:r\d+\]/i.test(texto)) return texto;
  return texto.replace(/\s*\[ESIM:[0-9a-f-]{36}:r\d+\]/gi, '')
    .replace(/\bCNPJ\s+(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})\b/g, 'CNPJ $1.$2.$3/$4-$5').trim();
}
